import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Chip from '@mui/material/Chip';
import { Link } from 'react-router-dom';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { cyberpunkColors } from './theme/cyberpunkTheme';

function NavBar() {

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(90deg, #0a0a0f 0%, #121218 50%, #0a0a0f 100%)',
        borderBottom: `1px solid ${cyberpunkColors.neonCyan}`,
        boxShadow: `0 0 20px rgba(0, 255, 255, 0.3)`,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Orbitron", sans-serif',
                  fontWeight: 700,
                  fontSize: { xs: '1.2rem', md: '1.5rem' },
                  color: '#ffffff',
                  letterSpacing: '0.05em',
                  textShadow: '0 0 10px rgba(255, 255, 255, 0.5)',
                }}
              >
                EC2
              </Typography>
              <Box
                sx={{
                  backgroundColor: cyberpunkColors.neonCyan,
                  borderRadius: { xs: '4px', md: '6px' },
                  px: { xs: 0.8, md: 1 },
                  py: { xs: 0.2, md: 0.3 },
                  ml: 0.5,
                  boxShadow: `0 0 15px ${cyberpunkColors.neonCyan}99`,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: '"Orbitron", sans-serif',
                    fontWeight: 700,
                    fontSize: { xs: '1rem', md: '1.3rem' },
                    color: '#000000',
                    letterSpacing: '0.05em',
                    lineHeight: 1.2,
                  }}
                >
                  HUB
                </Typography>
              </Box>
            </Box>
          </Link>

          {/* Spot Finder Chip */}
          <Chip
            component={Link}
            to="/SpotAnalyzer"
            icon={<TrendingDownIcon sx={{ color: `${cyberpunkColors.neonGreen} !important` }} />}
            label="SPOT FINDER"
            clickable
            sx={{
              backgroundColor: 'rgba(0, 255, 65, 0.15)',
              border: `1px solid ${cyberpunkColors.neonGreen}`,
              color: cyberpunkColors.neonGreen,
              fontFamily: '"Orbitron", sans-serif',
              fontWeight: 600,
              fontSize: { xs: '0.7rem', md: '0.8rem' },
              letterSpacing: '0.1em',
              px: { xs: 0.5, md: 1 },
              height: { xs: 28, md: 32 },
              boxShadow: `0 0 10px rgba(0, 255, 65, 0.3)`,
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 255, 65, 0.25)',
                boxShadow: `0 0 20px rgba(0, 255, 65, 0.5)`,
                transform: 'scale(1.05)',
              },
              '& .MuiChip-icon': {
                marginLeft: '8px',
              },
            }}
          />
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NavBar;
